import { Link } from "react-router-dom";
import { Star, StarOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { careLevels } from "@/config/constants";

const ProtocolCard = ({ protocol, isFavorite, onToggleFavorite }) => {
  return (
    <Card className="group hover:border-primary/50 transition-colors">
      <CardHeader className="pb-2">
        <div className="flex items-start justify-between">
          <Link to={`/protocol/${protocol.id}`} className="flex-1">
            <CardTitle className="font-heading text-lg group-hover:text-primary transition-colors" data-testid={`protocol-card-${protocol.id}`}>
              {protocol.name}
            </CardTitle>
          </Link>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8 shrink-0"
            onClick={(e) => {
              e.preventDefault();
              onToggleFavorite(protocol.id);
            }}
            data-testid={`favorite-btn-${protocol.id}`}
          >
            {isFavorite ? (
              <Star className="h-4 w-4 fill-yellow-500 text-yellow-500" />
            ) : (
              <StarOff className="h-4 w-4 text-muted-foreground" />
            )}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-1">
          {protocol.care_levels?.map((level) => (
            <Badge 
              key={level.level} 
              variant="outline" 
              className={`care-badge-${level.level} text-xs`}
            >
              {careLevels[level.level]?.shortLabel || level.level.toUpperCase()}
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ProtocolCard;
